export default {
    common: {
        title: 'Content AI',
        socialPlanner: 'Planificateur médias sociaux',
        blog: 'Blogue',
        funnel: 'Tunnel',
        website: 'Site Web',
        mediaLibrary: 'Bibliothèque médiatique',
        email: 'Courriel',
        words: 'Mots',
        variations: 'Variantes',
        thisIsPaidService: 'Cette fonctionnalité est un service payant et entraînera des frais en fonction de votre utilisation',
        all: 'Tous',
    },
};
